import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Dialog, withMobileDialog } from '@ellucian/react-design-system/core';
import { setSettingsValue } from './redux/slices/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';
const selectShowSidebarDialog = state => state.settings.showMobileSidebarDialog;
const SidebarDialog = props => {
    const {
        children = null,
        onClose: onCloseProp = () => {},
    } = props;
    const dispatch = useDispatch();
    const open = useSelector(selectShowSidebarDialog);
    const onClose = useCallback(() => {
        dispatch(setSettingsValue({
            name: 'showMobileSidebarDialog',
            value: false,
        }));
        onCloseProp();
    }, [dispatch]);
    return <Dialog fullScreen={true} onClose={onClose} open={open}>{children}</Dialog>;
};
SidebarDialog.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
};
export default withMobileDialog()(SidebarDialog);
